import { CloseCircle } from 'public/images/svg/close-circle'
import styled from 'styled-components'

export const Container = styled.div`
  cursor: pointer;
`

type ImageProps = {
  position?: string
  top?: number
  left?: number
  height: number
  width: number
}

export const Image = styled(CloseCircle)<ImageProps>`
  ${(props) => props.position && `position: ${props.position};`}
  ${(props) => props.top && `top: ${props.top}px;`}
  ${(props) => props.left && `left: ${props.left}px;`}
  height: ${(props) => props.height};
  width: ${(props) => props.height};
`
